<template>
    <div>
        <div>
            <b-nav tabs>
                <template v-if="canViewSuperAdmin">
                    <b-nav-item router-link to="user-management">
                        <icon name="file"></icon>
                        ผู้ใช้งาน
                    </b-nav-item>&nbsp;
                </template>
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
import {
    canViewSuperAdmin
} from "../../util/Permissions"

export default {
    name: "user-management",
    computed: {
        canViewSuperAdmin
    }
}
</script>

<style scoped></style>
